import { Button } from '../../ui/Button'
import type { ReadinessItem } from '../../core/readiness'
import type { SummaryPrice } from './ConfigSummary'

/**
 * The narrow-screen stand-in for the summary card's action.
 *
 * At ≤720px the summary sits after the form, so the price and the one primary
 * action ride along at the bottom of the viewport instead. Shown and hidden by
 * a media query only (`.summary-bar`), never by a width check in script, and
 * the summary card's own button is hidden at the same breakpoint — so exactly
 * one primary action is visible at any width.
 */
export function SummaryBar({ price, readiness, submitted, continueLabel }: { price: SummaryPrice; readiness: readonly ReadinessItem[]; submitted: boolean; continueLabel: string }) {
  const blocks = readiness.filter((item) => item.level === 'block')
  const first = blocks[0]
  return <div className="summary-bar">
    <div className="summary-bar-status">
      <span className={`summary-bar-price${price.caution ? ' summary-bar-price--caution' : ''}`}>{price.compact}</span>
      {/* Neutral until the first submit, like the card's checklist (D3): the page does not turn red while the tenant is still typing. */}
      {first && <a className={`summary-bar-fix${submitted ? ' summary-bar-fix--submitted' : ''}`} href={first.targetId ? `#${first.targetId}` : '#configure-form'}>{blocks.length} to fix</a>}
    </div>
    <Button type="submit" form="configure-form" variant="primary">{continueLabel}</Button>
  </div>
}
